import { Link } from 'react-router-dom';
import { categories, hotKeywords } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-read-line text-base text-white"></i>
                </div>
                <span className="font-heading text-lg font-bold text-foreground-950">
                  韩国漫画网
                </span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                韩国漫画网站大全，海量免费韩漫在线看，支持下拉式阅读，实时追更热门漫画，日更不断更。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
                <a href="#quick-links">快速链接</a>
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
                <Link to="/category/all" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">分类浏览</Link>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">关于我们</Link>
              </div>
            </div>

            {/* Categories */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
                <a href="#categories-footer">热门分类</a>
              </h4>
              <div className="flex flex-wrap gap-2">
                {categories.filter(c => c.slug !== 'all').map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="px-2.5 py-1 rounded-md bg-background-200/70 text-xs text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            {/* Hot Keywords */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
                <a href="#hot-keywords">热门搜索</a>
              </h4>
              <div className="flex flex-wrap gap-2">
                {hotKeywords.slice(0, 8).map((kw) => (
                  <span
                    key={kw}
                    className="px-2.5 py-1 rounded-md bg-background-200/70 text-xs text-foreground-500 cursor-pointer"
                  >
                    {kw}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; 2020-2026 韩国漫画网 koreancomic.cn - 韩国漫画网站大全 | 免费韩漫在线看平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}